import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const HistoryWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid ${COLORS.borderGrey};
  padding: 15px 25px;
  &:last-child {
    border-bottom: none;
  }
  .flex-3 {
    display: flex;
    span {
      font-family: ${FONT_FAMILY.hellix.bold};
    }
    span:first-child {
      flex: 2;
      font-size: 16px;
      color: ${(props) => (props.category === 'EXPIRED' ? '#747474' : '#000')};
    }
    span:last-child,
    span:nth-child(2) {
      width: 100px;
      text-align: right;
      font-size: 14px;
    }

    span:nth-child(2) {
      color: ${(props) => (props.category === 'EXPIRED' ? '#747474' : '#FE0000')};
    }

    span:last-child {
      color: ${COLORS.lightGreen};
    }
  }
  .flex-2 {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    span {
      font-size: 14px;
      font-family: ${FONT_FAMILY.hellix.regular};
      color: ${COLORS.textLightGrey};
      align-self: center;
    }
    span:not(:first-child) {
      width: 100px;
      text-align: right;
      line-height: 135%;
    }
  }
`;

function InstaPointsCard({ historyData }) {
  return (
    <HistoryWrapper category={historyData?.category}>
      <div className="flex-3">
        <span>
          {historyData?.category &&
            historyData?.category?.charAt(0) + historyData?.category?.substring(1)?.toLowerCase()}
        </span>
        <span>{historyData?.debit}</span>
        <span>{historyData?.credit}</span>
      </div>
      <div className="flex-2">
        <span>{historyData?.action_date}</span>
        {historyData?.expiry_date && (
          <span>{historyData?.isExpired ? 'Expired on' : 'Expires on'}</span>
        )}
      </div>
      <div className="flex-2">
        <span>{historyData?.description}</span>
        <span>{historyData?.expiry_date}</span>
      </div>
    </HistoryWrapper>
  );
}

InstaPointsCard.propTypes = {
  historyData: PropTypes.object
};

export default InstaPointsCard;
